module.exports = __webpack_public_path__ + "static/media/dollar-inactive.01face69.svg";